import { render, staticRenderFns } from "./ReportDashboardByPlatformChannel.vue?vue&type=template&id=dda4c722&scoped=true&"
import script from "./ReportDashboardByPlatformChannel.vue?vue&type=script&lang=js&"
export * from "./ReportDashboardByPlatformChannel.vue?vue&type=script&lang=js&"
import style0 from "./ReportDashboardByPlatformChannel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportDashboardByPlatformChannel.vue?vue&type=style&index=1&id=dda4c722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda4c722",
  null
  
)

export default component.exports